// extracted by mini-css-extract-plugin
module.exports = {"editor_container":"ChatInput_editor_container__2-_ry","user_typing":"ChatInput_user_typing__GXH2A","placeholder":"ChatInput_placeholder__603W4"};